import React, { Component } from 'react';

import ReactGA from 'react-ga';

import Mousetrap from 'mousetrap';

import ContentAdd from 'material-ui/svg-icons/content/add'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Snackbar from 'material-ui/Snackbar';

import AssignmentAddDetail from './scenes/Assignments/components/AssignmentAddDetail';
import AssignmentDashboard from './scenes/Assignments/components/AssignmentDashboard';
import AssignmentDetail from './scenes/Assignments/components/AssignmentDetail';
import AssignmentList from './scenes/Assignments/components/AssignmentList';
import DeleteConfirmDialog from './components/DeleteConfirmDialog';

import Parse from 'parse';
import * as ParseService from './services/parse';

const fabStyles = {
  position: 'absolute',
  bottom: '24px',
  right: '24px',
};

class AssignmentSceneCoordinator extends Component {

  constructor(props) {
    super(props);

    this.state = {
      confirmItemDelete: false,
      flash: null,
      selectedItem: null,
      editItem: null,
      selectedDate: new Date(),
      showItemAdd: false,
    }

    this.handleItemSelected = this.handleItemSelected.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview('/assignments');

    Mousetrap.bind('c', this.handleShowItemAdd);
  }

  componentWillUnmount() {
    Mousetrap.unbind('c');
  }

  handleActiveDateChange = (info) => {
    this.setState({selectedDate: info.activeStartDate});
  }

  handleDateChange(date) {
    this.setState({selectedDate: date});
  }

  handleDetailRequestClose = () => {
    this.setState({
      selectedItem: null
    });
  }

  handleDetailRequestEdit = (item) => {
    this.setState({
      editItem: item,
      showItemAdd: true
    });
  }

  handleItemDelete = () => {
    const item = this.state.selectedItem;
    if (item == null) {
      return;
    }

    const that = this;
    ParseService.archive(item).then(
      function(obj) {
        console.log('Archived!');
        that.setState({
          selectedDate: that.state.selectedDate,
          selectedItem: null, 
          confirmItemDelete: false,
          flash: 'Assignment deleted.', 
        });
      },
      function(err) {
        console.log('Failed to archive with error ' + err);
        that.setState({confirmItemDelete: false});
      });
  }

  handleItemProgressChange = (e, item) => {
    const that = this;
    ParseService.toggleAssignmentProgress(item).then(
      function(obj) {
        if (that.state.selectedItem !== null && that.state.selectedItem.id === obj.id) {
          that.setState({selectedItem: obj});
        } else {
          that.forceUpdate();
        }
      },
      function(err) {
        console.log("Failed to update progress with error " + err);
      });
  }

  handleItemSelected(item) {
    this.setState({selectedItem: item});
  }

  handleShowItemAdd = () => {
    if (!this.state.showItemAdd) {
      this.setState({showItemAdd: true});
    }
  }

  render() {
    const selectedItem = this.state.selectedItem;
    const selectedDate = this.state.selectedDate;

    return (
      <div className="scene-box">
        <AssignmentDashboard 
          date={ selectedDate }
          onDateChange={ this.handleDateChange }
          onActiveDateChange={ this.handleActiveDateChange } />
        
        <AssignmentList
          date={ selectedDate }
          period='month'
          onItemSelected={ this.handleItemSelected }
          onProgressChange={ this.handleItemProgressChange } />
        
        { selectedItem != null ? (
          <div className='detail-container detail-container-inset detail-container--scrollable'>
            <AssignmentDetail 
              item={selectedItem} 
              onRequestClose={this.handleDetailRequestClose}
              onRequestEdit={this.handleDetailRequestEdit}
              onRequestDelete={() => this.setState({confirmItemDelete: true})}
              onProgressChange={this.handleItemProgressChange} />
          </div>
        ) : null }

        <FloatingActionButton
          primary={true}
          onClick={this.handleShowItemAdd}
          style={fabStyles} >
          <ContentAdd />
        </FloatingActionButton>

        { this.state.showItemAdd ? (
          <AssignmentAddDetail 
            onCancel={() => this.setState({editItem: null, showItemAdd: false})} 
            onSave={(assignment) => this.setState({selectedDate: this.state.selectedDate, editItem: null, showItemAdd: false, flash: 'Assignment saved successfully.'})}
            assignment={this.state.editItem} />
        ) : null }

        { this.state.confirmItemDelete ? (
          <DeleteConfirmDialog
            open={true}
            title={"Are you sure you want to delete \"" + this.state.selectedItem.get('title') + "\"?"}
            message="This Assignment will be removed from all syncing devices. You can not undo this action."
            onRequestCancel={() => this.setState({confirmItemDelete: false})}
            onRequestDelete={this.handleItemDelete} />
        ) : null }

        <Snackbar
          message={this.state.flash || ''}
          open={this.state.flash !== null}
          onRequestClose={() => this.setState({flash: null})}
          autoHideDuration={4000} />
        
      </div>
    );
  }
}

export default AssignmentSceneCoordinator;


// WEBPACK FOOTER //
// ./src/AssignmentSceneCoordinator.js